import { VERIFICATION_FORM }  from "../constants";

const initialState = {
    lastName: "",
    dateOfBirth: "",
    last4Ssn: "",
    confirmationNumber: ""
}

const verificationReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
         case VERIFICATION_FORM.VERIFICATION_FORM_DETAILS:
            return {
                 ...state,
                 ...payload.payload
             }
        case VERIFICATION_FORM.VERIFICATION_FORM_SUCCESS:
            return {
                ...state,
                ...payload
            }
        case VERIFICATION_FORM.VERIFICATION_FORM_FAIL:
            return {
                ...state,
                ...initialState
            }
        default:
            return state;
    }
}

export default verificationReducer;